// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2X8LC","right":"Footer_right__2nHvE","buttons":"Footer_buttons__1TuHk"};